/**
 * @generated SignedSource<<97ecbc7da1a55e6e70f104d902a886ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Persolog_ClassType = "D" | "G" | "I" | "S";
import { FragmentRefs } from "relay-runtime";
export type persologClassForm_PersologClassFragment$data = {
  readonly classType: Persolog_ClassType;
  readonly image: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly text: string;
  readonly title: string;
  readonly " $fragmentType": "persologClassForm_PersologClassFragment";
};
export type persologClassForm_PersologClassFragment$key = {
  readonly " $data"?: persologClassForm_PersologClassFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"persologClassForm_PersologClassFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "persologClassForm_PersologClassFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "classType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Persolog_Class",
  "abstractKey": null
};

(node as any).hash = "620079bbbd78294114ef2a9b0dc2539a";

export default node;
